import axios from '@/axios.js'

export default {
  getWidgetSettings: async (resortUuid) => {
      const response = await axios.editorapi.get(`v4/widgets/${resortUuid}/settings`)
      return response.data.object
  },

  updateWidgetSettings: async (resortUuid, payload) => {
      const response = await axios.editorapi.patch(`v4/widgets/${resortUuid}/settings`, payload)
      return response.data
  }
}
